<template>
  <div class="logistics-jobs-list" v-if="role">
    <!------------ Scheduled Orders ------------>
    <collapse-transition>
      <div v-show="showScheduled">
        <div class="header" @click="updateOrdersLogisticsAgent">
          <i class="fa fa-bell has-text-danger pad" />
          {{ $t("logistics.scheduled") }}
        </div>
        <div v-if="none(scheduledOrders)" class="button is-info is-outlined none">{{ $t("none") }}</div>
        <LogisticsJobsItem v-for="t in scheduledOrders" :t="t" :key="t.id" />
      </div>
    </collapse-transition>

    <!------------ Ongoing Orders ------------>
    <collapse-transition>
      <div v-show="showOngoing">
        <div class="header">
          <i class="fa fa-cog fa-spin pad has-text-primary" />
          {{ $t("logistics.ongoing") }}
        </div>
        <div v-if="none(ongoingOrders)" class="button is-info is-outlined none">{{ $t("none") }}</div>
        <LogisticsJobsItem v-for="t in ongoingOrders" :t="t" :key="t.id" />
      </div>
    </collapse-transition>

    <!------------ Completed / Past Orders ------------>
    <collapse-transition>
      <div v-show="showCompleted">
        <div class="header">
          <i class="fa fa-history pad has-text-link" />
          {{ $t("logistics.completed") }}
        </div>
        <div v-if="none(pastOrders)" class="button is-info is-outlined none">{{ $t("none") }}</div>
        <LogisticsJobsItem v-for="t in pastOrders" :t="t" :key="t.id" />
      </div>
    </collapse-transition>

    <!-- Footer tags -->
    <div class="debug-info">
      <span class="tags has-addons is-pulled-right">
        <span
          class="tag is-link has-text-weight-medium"
          @click="goto(`shop/${role.business.id}`)"
        >{{ shortenString(role.business.name, 20) }}</span>
        <span
          class="tag is-dark has-text-weight-medium"
          @click="goto('profile')"
        >{{ $store.getters.getUserMobile }}</span>
        <span class="tag is-light" @click="updateOrdersLogisticsAgent">{{ jobsUpdatedAt }}</span>
      </span>
    </div>
  </div>

  <div v-else class="notification">
    <i class="fa fa-kiwi-bird" style="margin-bottom:10px; font-size:5em; color:brown" />
    <p class="title has-text-info">{{ $t("commerce.not-allowed") }}</p>
    <a class="button is-success" style="margin-top:10px" @click="goHome">Go Home</a>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import vehicles from "@/vehicles";
import { sounds } from "../functions.js";
import LogisticsJobsItem from "@/components/LogisticsJobsItem.vue";

export default {
  name: "LogisticsJobsList",
  components: {
    LogisticsJobsItem,
  },
  props: {
    filters: Object,
  },
  data() {
    return {
      workflows: [], // fleet workflows to get icons
      // isWorking: true
    };
  },
  computed: {
    role() {
      return this.$store.getters.getLogisticsAgentRole;
    },
    workflow() {
      return this.role.workflow;
    },
    currency() {
      return this.currencySymbol(this.role.business.country);
    },
    search() {
      if (!this.filters) return null;
      return this.filters.search;
    },
    // return this.$store.getters.getLogisticsAgentNewOrders;
    scheduledOrders() {
      // return this.$store.getters.getLogisticsAgentScheduledOrders;
      var orders = this.$store.getters.getLogisticsAgentScheduledOrders;
      return this.filterSearch(orders);
    },
    ongoingOrders() {
      // return this.$store.getters.getLogisticsAgentOngoingOrders;
      var orders = this.$store.getters.getLogisticsAgentOngoingOrders;
      return this.filterSearch(orders);
    },
    pastOrders() {
      var orders = this.$store.getters.getLogisticsAgentPastOrders;
      return this.filterSearch(orders);
    },
    jobsUpdatedAt() {
      var dt = this.$store.state.logisticsAgentTransactionsUpdatedAt;
      var time = this.hhmmTime(dt);
      return time;
      // return `${this.$t("updated")} ${time}`;
    },
    showScheduled() {
      if (!this.filters) return false;
      return this.filters.scheduled;
    },
    showOngoing() {
      if (!this.filters) return false;
      return this.filters.ongoing;
    },
    showCompleted() {
      if (!this.filters) return false;
      return this.filters.completed;
    },
  },
  created() {
    this.getFleetWorkflows();
  },
  mounted() {
    this.updateOrdersLogisticsAgent();
    setInterval(() => this.updateOrdersLogisticsAgent(), 1000 * 60);
  },
  activated() {
    this.updateOrdersLogisticsAgent();
  },
  methods: {
    none(arr) {
      if (!arr || arr.length === 0) return true;
      return false;
    },
    filterSearch(orders) {
      return orders.filter((o) =>
        JSON.stringify(o).toLowerCase().includes(this.search)
      );
    },
    updatedAt(t) {
      return this.timeAgo(t.updated_at);
      // var minsAgo = (new Date() - new Date(t.updated_at)) / (1000 * 60);
      // var updated = `${Math.round(minsAgo)} minutes ago`;
      // return updated;
    },
    driverName(t) {
      // minutesAgo(t.created_at)
      if (!t.driver) return "None";
      if (t.driver.name === "") return t.driver.phone_number;
      return this.shortenString(t.driver.name, 30);
    },
    getFleetWorkflows() {
      this.$store
        .dispatch("getWorkflows", this.role.business_id)
        .then((res) => {
          console.log("fleet workflows", res.data);
          if (res.data) this.workflows = res.data;
        })
        .catch((err) => this.apiError(err));
    },
    icon(t) {
      var fleet = this.workflows.find((w) => w.id === t.workflow_id);
      if (!fleet || !fleet.data.icon) return vehicles.img("Balloon");
      var iconName = fleet.data.icon;
      return vehicles.img(iconName);
    },
    isOld(t) {
      return this.hoursAgo(t.created_at) > 24;
    },
    prettyDate(t) {
      var dt = new Date(t.created_at);
      return dt.toLocaleDateString();
    },
    newOrderStyle(t) {
      var color = this.bulmaColor("warning");
      if (this.secondsAgo(t.created_at) > 180)
        color = this.bulmaColor("danger");
      return `background-color:${color}`;
    },
    openCommerceSettings() {
      this.displayModal(".commerce-settings-modal");
      EventBus.$emit("OPEN_COMMERCE_SETTINGS");
    },
    openOrder(t) {
      // sounds("navigate1");
      this.gotoDelay("/logistics_order/" + t.id);
    },
    openOrderDetails(t) {
      if (this.isWorking) sounds("navigate1");
      EventBus.$emit("OPEN_ORDER_DETAILS", t);
      this.$nextTick(() => this.displayModal(".order-details-modal"));
    },
    prettyState(t) {
      // if (t.state === "confirmed") return this.$t("ecommerce.being-prepared");
      // if (t.state === "ready") return this.$t("ecommerce.waiting-for-pickup"); // if take-away
      // if (t.state === "completed") return "Completed";
      // if (t.state === "timed_out") return "Expired";
      return t.state;
    },
    stateClass(t) {
      var tagClass = "is-dark";
      if (t.state === "confirmed") tagClass = "is-warning";
      if (t.state === "ready") tagClass = "is-orange";
      if (t.state === "completed") tagClass = "is-success";
      if (t.state === "timed_out") tagClass = "is-danger";
      return tagClass;
    },
    orderValue(t) {
      return t.data.delivery.order_value; //t.data.order.order_value;
    },
    farePrice(t) {
      return t.data.fare.price;
    },
  },
};
</script>

<style scoped>
.logistics-jobs-list {
  margin-bottom: 44px;
}
.header {
  padding-left: 16px;
  margin-top: 14px;
  margin-bottom: 2px;
  text-align: left;
  font-size: 1.25rem;
  font-weight: 500;
}
.transaction {
  position: relative;
  border-radius: 10px;
  border: 1px solid lightgrey;
  box-shadow: 0px 1px 1px lightgrey;
}
.columns {
  margin: 0 8px;
  padding: 4px;
}
.column.is-1 {
  padding: 0 0;
}
.column.middle {
  padding-right: 0;
}
/* body { margin: 2em; } */
p {
  margin-bottom: 0px !important;
}
.ticket {
  background-color: azure;
  border: 2px dotted grey;
  padding: 4px;
  /* font-family: "Bookman Old Style", "Times New Roman", Times, serif; */
}
.ticket p {
  margin-top: -10px;
  font-size: 0.8em;
  font-weight: 600;
}
.pad {
  width: 16px;
  margin-right: 12px;
}
.pulse {
  padding: 3px;
  border-radius: 50%;
  animation: shadow-pulse 1s infinite;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(255, 255, 255, 0.95);
  }
  100% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0.05);
  }
}
.is-orange {
  background-color: orange;
}
.debug-info {
  position: fixed;
  bottom: 0px;
  box-shadow: 1px 1px 1px grey;
  width: 100vw;
  padding: 10px;
  backdrop-filter: blur(5px);
}
.none {
  font-size: 1.25rem;
  width: 100%;
}
.is-narrow img {
  width: 50px;
}
.tag {
  padding: 6px;
}
.state-tag {
  /* float: right;
  margin-right: -35px;
  margin-top: -7px; */
  position: absolute;
  right: 10px;
  top: 10px;
  font-weight: 500;
}
.updated-tag {
  /* float: right; */
  position: absolute;
  right: 10px;
  bottom: 10px;
}
</style>